import { render, staticRenderFns } from "./ProfileTabsThree.vue?vue&type=template&id=ee6aec20&scoped=true&"
import script from "./ProfileTabsThree.vue?vue&type=script&lang=js&"
export * from "./ProfileTabsThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee6aec20",
  null
  
)

export default component.exports